  export const cloudTopics: string[] = [
    "Cloud Computing",
    "VPS",
    "Servidor Virtual",
    "Infraestructura en la Nube",
    "Instancias Virtuales",
    "Servidor en la Nube",
    "Plataforma en la Nube",
    "Kubernetes",
    "Docker",
    "Virtualización",
    "Containers",
    "Elastic Cloud",
    "Cloud Server",
    "Microservicios",
    "SaaS",
    "PaaS",
    "IaaS",
    "Edge Computing",
    "Multi-Cloud",
    "Private Cloud",
    "Public Cloud",
    "Hybrid Cloud",
    "AI Cloud",
    "Compute Engine",
    "Auto Scaling"
  ];